import React, { useRef, useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import { app } from '../firebase.js';
import { getFirestore } from '@firebase/firestore';
import { collection, query, getDocs, where, getDoc, orderBy, deleteDoc, writeBatch, runTransaction } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import swal from 'sweetalert';
import { useNavigate, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { doc, updateDoc } from "firebase/firestore";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import profilePictureContImage from '../Images/defprofile.png'
import { Timestamp } from '@firebase/firestore';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2';
import ReactTimePicker from 'react-time-picker';
import { ORGANIZATION_NAME } from '../branding';
import { buildAdmissionConfirmationEmail, buildAdmissionFeeReceiptEmail } from '../utils/emailTemplates';

const getTodayDateInputValue = () => {
  const today = new Date();
  const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000);
  return localDate.toISOString().slice(0, 10);
};

const ADMISSIONS_PHONE_DISPLAY = '+254 727 634 101';
const EMAIL_API_URL = 'https://us-central1-ubunifu-college.cloudfunctions.net/api/send-email';
const SMS_API_URL = 'https://us-central1-ubunifu-college.cloudfunctions.net/api/send-sms';
const ADMISSION_FEE_SETTINGS_DOC = 'admissionFee';
const DEFAULT_ADMISSION_FEE_AMOUNT = 2000;


function ViewStudentComp() {

  const navigate = useNavigate();
  const location = useLocation();
  const db = getFirestore(app);
  const auth = getAuth();

  // Receive data from the previous page
  useEffect(() => {
    const data = location.state?.myData;
    setMyData(data);
  }, [location.state]);
  const [myData, setMyData] = useState(null); // State to store the received data

  console.log(myData)
  ////

  const [userName, setUsername] = useState();
  const [theuserType, setuserType] = useState()
  const [thecourse, setcourse] = useState();
  const [theaboutMe, setaboutMe] = useState();
  const [thewhyInterested, setwhyInterested] = useState();
  const [thecohort, setcohort] = useState();
  const [thefeePayment, setfeePayment] = useState();
  const [thesessionTime, setsessionTime] = useState();
  const [thenationality, setnationality] = useState();
  const [theclassType, setclassType] = useState();
  const [theappDate, setappDate] = useState();
  const [theAddress, setAddress] = useState();
  const [thehear, sethear] = useState();
  const [theinterviewdate, setinterviewdate] = useState();
  const [mcourseDuration, setmcourseDuration] = useState();
  const [courseDurationMonths, setCourseDurationMonths] = useState();
  const [theAdmissionNumber, setAdmissionNumber] = useState();
  const [theYearOfBirth, setYearOfBirth] = useState();
  const [studentAdmissionDate, setStudentAdmissionDate] = useState();
  const [studentRecord, setStudentRecord] = useState({});

  const [theuserEmail, setuserEmail] = useState();
  const [thephoneNumber, setphoneNumber] = useState();

  const [classStartDate, setClassStartDate] = useState('');

  const [coursesList, setCoursesList] = useState([]);

  // State to store classmates
  const [classmates, setClassmates] = useState([]);
  const [theprofilePic, setStudentProfPic] = useState();
  const [studentsList, setStudentList] = useState([]);
  const [themcoursePrice, setmcoursePrice] = useState();
  const [totalAmountReceived, setTotalAmountReceived] = useState(0);
  const [thefeebalanceState, setfeebalanceState] = useState(0);

  const [modalShowUp, setModalShowUp] = useState(false);
  const [modalShowUp2, setModalShowUp2] = useState(false);
  const [admissionFeeModalShow, setAdmissionFeeModalShow] = useState(false);
  const [isRecordingAdmissionFee, setIsRecordingAdmissionFee] = useState(false);
  const [configuredAdmissionFeeAmount, setConfiguredAdmissionFeeAmount] = useState(DEFAULT_ADMISSION_FEE_AMOUNT);
  const [admissionFeeForm, setAdmissionFeeForm] = useState({
    amount: String(DEFAULT_ADMISSION_FEE_AMOUNT),
    paymentMethod: 'Mpesa Paybill',
    paymentReference: '',
    paymentDate: getTodayDateInputValue(),
    notes: ''
  });

  useEffect(() => {
    let cancelled = false;

    const fetchAdmissionFeeSetting = async () => {
      try {
        const settingsSnap = await getDoc(doc(db, 'Settings', ADMISSION_FEE_SETTINGS_DOC));
        const amount = Number(settingsSnap.data()?.amountKes || DEFAULT_ADMISSION_FEE_AMOUNT);
        const safeAmount = Number.isFinite(amount) && amount > 0 ? amount : DEFAULT_ADMISSION_FEE_AMOUNT;

        if (!cancelled) {
          setConfiguredAdmissionFeeAmount(safeAmount);
          setAdmissionFeeForm((previousForm) => ({
            ...previousForm,
            amount: String(safeAmount)
          }));
        }
      } catch (error) {
        console.error('Failed to load admission fee setting:', error);
      }
    };

    fetchAdmissionFeeSetting();

    return () => {
      cancelled = true;
    };
  }, [db]);


  useEffect(() => {
    const fetchData = async () => {
      //, orderBy("rank")
      const q = query(collection(db, 'courses'), orderBy("rank"));
      const querySnapshot = await getDocs(q);
      const studentsItem = [];
      querySnapshot.forEach((doc) => {
        studentsItem.push({ id: doc.id, ...doc.data() });
      });
      setCoursesList(studentsItem);

    };

    fetchData();
  }, []);


  function MyUpdateModal(props) {
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Student Not joining
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Select a reason for not joining</Form.Label>
            <Form.Select aria-label="Default select example" ref={selectNotJoiningReason} >
              <option value="">Select a reason</option>
              <option value="Financial Constraints">Financial Constraints</option>
              <option value="Personal Reasons">Personal Reasons</option>
              <option value="Alternative Offer Accepted">Alternative Offer Accepted</option>
              <option value="Change in Career Goals">Change in Career Goals</option>
              <option value="Academic Concerns">Academic Concerns</option>
              <option value="Health Issues">Health Issues</option>
              <option value="Family Commitments">Family Commitments</option>
              <option value="Location Issues">Location Issues</option>
              <option value="Program Not a Good Fit">Program Not a Good Fit</option>
              <option value="Job Offer or Promotion">Job Offer or Promotion</option>
              <option value="Travel or Relocation">Travel or Relocation</option>
              <option value="Insufficient Support Services">Insufficient Support Services</option>
              <option value="Lack of Program Flexibility">Lack of Program Flexibility</option>
              <option value="Incompatibility with Schedule">Incompatibility with Schedule</option>
              <option value="Program Length">Program Length</option>
              <option value="Uncertainty about Future Plans">Uncertainty about Future Plans</option>
              <option value="Concerns About Quality of Education">Concerns About Quality of Education</option>
              <option value="Difficulty with Online Learning">Difficulty with Online Learning</option>
              <option value="Unsatisfactory Campus Facilities">Unsatisfactory Campus Facilities</option>
              <option value="Difficulty in Meeting Prerequisites">Difficulty in Meeting Prerequisites</option>
              <option value="Concerns About Class Size">Concerns About Class Size</option>
              <option value="Unfamiliarity with Course Content">Unfamiliarity with Course Content</option>
              <option value="Negative Feedback from Current Students">Negative Feedback from Current Students</option>
              <option value="Limited Interaction with Faculty">Limited Interaction with Faculty</option>
              <option value="Other">Other</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
          <Button variant="primary" id='submitBtn' onClick={updateStudent} >Submit</Button>
          <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            <span> Submitting...</span>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function MyUpdateModal2(props) {
    return (
      <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Change Course
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Select a new course</Form.Label>
            <Form.Select aria-label="Default select example" ref={updatedCourseRef} >
              {coursesList.map((theIntake) => (
                <option key={theIntake.id} value={theIntake.mcourseName} >{theIntake.mcourseName}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-dark' onClick={props.onHide}>Close</Button>
          <Button variant="primary" id='submitBtn' onClick={changeCourse} >Update</Button>
          <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            <span> Updating...</span>
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }


  const selectNotJoiningReason = useRef();
  const updatedCourseRef = useRef();


  function updateStudent() {
    const notJoiningReason = selectNotJoiningReason.current.value;

    document.getElementById("submitBtn").style.display = "none";
    document.getElementById("spinnerbtn").style.display = "block";

    updateDoc(doc(db, 'users', myData), {
      userStatus: 'Did Not Join',
      notJoiningReason: notJoiningReason,
      updateNotJoiningDate: Timestamp.now(),

    }).then(() => {
      swal("Success!", "Status Updated successfully", "success");
      window.location.reload();
    });
  }



  function changeCourse() {
    const updatedCourse = updatedCourseRef.current.value;

    document.getElementById("submitBtn").style.display = "none";
    document.getElementById("spinnerbtn").style.display = "block";

    updateDoc(doc(db, 'users', myData), {
      course: updatedCourse,
      updateCourseTime: Timestamp.now(),

    }).then(() => {
      swal("Success!", "Course Updated successfully", "success");
      window.location.reload();
    });
  }



  useEffect(() => {

    const fetchData = async () => {
      if (myData) {
        try {
          const querySnapshot = await getDocs(query(collection(db, 'users'), where('userId', '==', myData)));
          let cohortDate = '';
          let myCourse = '';
          let viewCourse = '';
          querySnapshot.forEach(async (doc) => {
            const studentData = doc.data();
            setStudentRecord(studentData);

            let bio = studentData.bio;
            let userType = studentData.userStatus;
            let course = studentData.course;
            let aboutMe = studentData.aboutMe;
            let whyInterested = studentData.whyInterested;

            viewCourse = course;

            let cohort = studentData.cohort;
            let feePayment = studentData.feePayment;
            let sessionTime = studentData.sessionTime;
            let nationality = studentData.nationality;
            let classType = studentData.classType;
            let appDate = studentData.appDate;
            let Address = studentData.Address;
            let hear = studentData.hear;
            let interviewdate = studentData.interviewdate;
            let admissionNumber = studentData.admissionNumber;
            let yearOfBirth = studentData.yearOfBirth;
            let admissionDate = studentData.admissionDate;

            let phoneNumber = studentData.phoneNumber;
            let userEmail = studentData.userEmail;

            const profilePic = studentData.profilePic || profilePictureContImage;

            setphoneNumber(phoneNumber)
            setuserEmail(userEmail)
            setStudentProfPic(profilePic)


            cohortDate = cohort;
            myCourse = course;

            setUsername(bio)
            setuserType(userType)
            setcourse(course)
            setaboutMe(aboutMe)
            setwhyInterested(whyInterested)

            setcohort(cohort)
            setfeePayment(feePayment)
            setsessionTime(sessionTime)
            setnationality(nationality)
            setclassType(classType)
            setappDate(appDate)
            setAddress(Address)
            sethear(hear)
            setinterviewdate(interviewdate)
            setAdmissionNumber(admissionNumber)
            setYearOfBirth(yearOfBirth)
            setStudentAdmissionDate(admissionDate)
          });

          // Fetch classmates
          const classmatesQuerySnapshot = await getDocs(query(collection(db, 'users'), where('cohort', '==', cohortDate), where('course', '==', myCourse)));
          const classmatesData = [];
          classmatesQuerySnapshot.forEach(doc => {
            classmatesData.push(doc.data());
          });
          setClassmates(classmatesData)


          const feehistory = await getDocs(query(collection(db, 'Income'), orderBy("paymentDate", 'desc'), where("studentId", "==", myData)));
          const feePayments = [];
          let totalAmount = 0;
          feehistory.forEach((docSnap) => {
            feePayments.push({ id: docSnap.id, ...docSnap.data() });
            let data = docSnap.data();
            totalAmount += parseFloat(data.incomeAmount); // Convert string to number and add to total
          });
          console.log(feePayments)
          //setFeeHistory(feePayments)
          setStudentList(feePayments);
          setTotalAmountReceived(totalAmount);


          const q = query(collection(db, "courses"), where("mcourseName", "==", viewCourse));
          getDocs(q).then((QuerySnapshot) => {
            QuerySnapshot.forEach((doc) => {
              const mcoursePrice = doc.data().mcoursePrice;
              const mcourseDuration = doc.data().mcourseDuration;
              const courseDuration = doc.data().courseDuration;
              setmcoursePrice(mcoursePrice)
              setmcourseDuration(mcourseDuration)
              setCourseDurationMonths(courseDuration ?? mcourseDuration)

            })
          })






        } catch (error) {
          console.error('Error fetching data from Firebase:', error);
        }
      }
    };

    // Initial fetch
    fetchData();
  }, [myData, db]);

  const normalizedStatus = (theuserType || '').trim().toLowerCase();
  const canViewCertificate = normalizedStatus === 'completed';
  const canViewSchoolId = normalizedStatus === 'student' || normalizedStatus === 'completed';

  const handleViewCertificate = () => {
    if (!canViewCertificate) {
      swal("Not Graduated", "Certificate is only available for graduated students.", "error");
      return;
    }
    const params = new URLSearchParams({
      userId: myData || '',
      name: userName || '',
      course: thecourse || '',
      cohort: thecohort || '',
      duration: mcourseDuration || ''
    });
    window.open(`/view-certificate?${params.toString()}`, '_blank', 'noopener,noreferrer');
  };

  const handleViewSchoolId = () => {
    if (!canViewSchoolId) {
      swal("Not Admitted", "School ID is only available for admitted students.", "error");
      return;
    }
    const params = new URLSearchParams({
      userId: myData || '',
      name: userName || '',
      course: thecourse || '',
      cohort: thecohort || '',
      duration: mcourseDuration || ''
    });
    window.open(`/view-school-id?${params.toString()}`, '_blank', 'noopener,noreferrer');
  };

  ///



  const getFirstName = (fullName) => {
    if (fullName) {
      return fullName.split(' ')[0];
    }
    return '';
  };

  function viewStudent(userId) {
    navigate('/view-student', { state: { myData: userId } });
  }

  const handleViewReceipt = (paymentRecord) => {
    const receiptNumber = paymentRecord?.invoiceNumber || paymentRecord?.receiptNumber;

    if (!receiptNumber) {
      swal("Receipt Unavailable", "This payment record does not have a receipt number yet.", "warning");
      return;
    }

    window.open(`/view-receipt?${encodeURIComponent(receiptNumber)}`, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    const coursePrice = parseFloat(themcoursePrice || 0);
    const paid = parseFloat(totalAmountReceived || 0);
    if (!Number.isFinite(coursePrice) || !Number.isFinite(paid)) return;
    setfeebalanceState(coursePrice - paid);
  }, [themcoursePrice, totalAmountReceived]);

  const formatKES = (value) => {
    const num = parseFloat(value || 0);
    if (!Number.isFinite(num)) return '0';
    return num.toLocaleString();
  };

  const formatDateTime = (value) => {
    if (!value) return 'N/A';
    let dateObj = value;
    if (value instanceof Timestamp) {
      dateObj = value.toDate();
    } else if (value?.seconds) {
      dateObj = new Date(value.seconds * 1000);
    } else if (!(value instanceof Date)) {
      dateObj = new Date(value);
    }
    if (Number.isNaN(dateObj.getTime())) return 'N/A';
    const datePart = dateObj.toLocaleDateString();
    const timePart = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${datePart} • ${timePart}`;
  };

  const statusSlug = String(theuserType || 'unknown').toLowerCase().replace(/\s+/g, '-');
  const isInactiveStudent = normalizedStatus === 'inactive';

  const formatStatusText = (value) => {
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    if (value === null || value === undefined || value === '') return 'N/A';
    return String(value).replace(/_/g, ' ');
  };

  const getStatusTone = (value) => {
    const normalizedValue = String(value || '').toLowerCase();
    if (['sent', 'paid', 'completed', 'active', 'yes'].includes(normalizedValue)) return 'success';
    if (['pending', 'processing', 'application received'].includes(normalizedValue)) return 'warning';
    if (normalizedValue.includes('failed') || normalizedValue.includes('cancelled')) return 'danger';
    if (normalizedValue.includes('skipped')) return 'muted';
    return 'default';
  };

  const getNextFollowUpSummary = () => {
    if (!studentRecord?.nextFollowUpAt) return 'No follow-up scheduled yet';
    if (studentRecord.nextFollowUpStatus === 'completed') return 'Automated follow-up completed';
    if (studentRecord.nextFollowUpStatus === 'cancelled') return 'Follow-up cancelled';
    return formatDateTime(studentRecord.nextFollowUpAt);
  };

  const handleAdmissionFeeInput = (event) => {
    const { name, value } = event.target;
    setAdmissionFeeForm((previousForm) => ({
      ...previousForm,
      [name]: value
    }));
  };

  const generateManualProspectRef = (paymentId) => {
    const year = new Date().getFullYear();
    return `UBN-${year}-${paymentId.slice(0, 8).toUpperCase()}`;
  };

  const resetAdmissionFeeForm = () => {
    setAdmissionFeeForm({
      amount: String(configuredAdmissionFeeAmount || DEFAULT_ADMISSION_FEE_AMOUNT),
      paymentMethod: 'Mpesa Paybill',
      paymentReference: '',
      paymentDate: getTodayDateInputValue(),
      notes: ''
    });
  };

  const formatAdmissionFeeAmount = (amount) => {
    const numericAmount = Number(amount || 0);
    return `KES ${numericAmount.toLocaleString('en-KE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };

  const getKenyanSmsNumber = (phoneNumber = '') => {
    let cleaned = String(phoneNumber).replace(/[^\d+]/g, '');

    if (cleaned.startsWith('+254')) {
      cleaned = cleaned.replace('+', '');
    } else if (cleaned.startsWith('254')) {
      cleaned = cleaned;
    } else if (cleaned.startsWith('0')) {
      cleaned = `254${cleaned.slice(1)}`;
    } else if (/^[17]\d{8}$/.test(cleaned)) {
      cleaned = `254${cleaned}`;
    }

    return /^254[17]\d{8}$/.test(cleaned) ? `+${cleaned}` : '';
  };

  const sendAdmissionFeeReceipt = async ({ amount, paymentReference, paymentMethod, paymentDate, prospectAdmissionNumber, paymentId }) => {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return { emailStatus: 'skipped_no_auth', smsStatus: 'skipped_no_auth' };
    }

    const token = await currentUser.getIdToken();
    let emailStatus = theuserEmail ? 'pending' : 'skipped_no_email';
    let smsStatus = 'skipped_non_kenyan';
    let emailError = '';
    let smsError = '';

    if (theuserEmail) {
      try {
        const emailResponse = await fetch(EMAIL_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            email: theuserEmail,
            subject: `Admission fee receipt - ${ORGANIZATION_NAME}`,
            message: buildAdmissionFeeReceiptEmail({
              studentName: userName,
              course: thecourse,
              amount,
              paymentReference,
              paymentMethod,
              paymentDate,
              prospectAdmissionNumber,
            }),
          })
        });

        emailStatus = emailResponse.ok ? 'sent' : 'failed';
        if (!emailResponse.ok) {
          emailError = `Email API returned ${emailResponse.status}`;
        }
      } catch (error) {
        emailStatus = 'failed';
        emailError = error.message || 'Receipt email failed';
      }
    }

    const smsPhoneNumber = getKenyanSmsNumber(thephoneNumber);
    if (smsPhoneNumber) {
      try {
        const smsResponse = await fetch(SMS_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            phoneNumber: smsPhoneNumber,
            message: `Hi ${userName || 'there'}, we have received your ${ORGANIZATION_NAME} admission fee of ${formatAdmissionFeeAmount(amount)}. Ref: ${paymentReference}. Admissions will guide you on interview scheduling. - Nutrition And Dietetics Academy`
          })
        });

        smsStatus = smsResponse.ok ? 'sent' : 'failed';
        if (!smsResponse.ok) {
          smsError = `SMS API returned ${smsResponse.status}`;
        }
      } catch (error) {
        smsStatus = 'failed';
        smsError = error.message || 'Receipt SMS failed';
      }
    }

    try {
      await updateDoc(doc(db, 'AdmissionFeePayments', paymentId), {
        receiptEmailStatus: emailStatus,
        receiptEmailError: emailError,
        receiptSmsStatus: smsStatus,
        receiptSmsError: smsError,
        receiptSentAt: Timestamp.now(),
      });
    } catch (error) {
      console.error('Error updating admission fee receipt status:', error);
    }

    return { emailStatus, smsStatus };
  };

  const recordAdmissionFeePayment = async () => {
    const amount = Number(configuredAdmissionFeeAmount || DEFAULT_ADMISSION_FEE_AMOUNT);

    if (!myData) {
      swal("Missing Student", "Open the student profile again before recording this payment.", "error");
      return;
    }

    if (!amount || amount <= 0 || !admissionFeeForm.paymentReference.trim() || !admissionFeeForm.paymentDate) {
      swal("Missing Details", "Enter the amount, payment reference, and payment date.", "error");
      return;
    }

    setIsRecordingAdmissionFee(true);

    try {
      const paymentDate = Timestamp.fromDate(new Date(`${admissionFeeForm.paymentDate}T12:00:00`));
      const paymentRef = doc(collection(db, 'AdmissionFeePayments'));
      const prospectAdmissionNumber = studentRecord.prospectAdmissionNumber || generateManualProspectRef(paymentRef.id);
      const currentUser = auth.currentUser;
      const batch = writeBatch(db);

      batch.set(paymentRef, {
        userId: myData,
        studentName: userName || '',
        studentEmail: theuserEmail || '',
        phoneNumber: thephoneNumber || '',
        course: thecourse || '',
        cohort: thecohort || '',
        prospectAdmissionNumber,
        amount,
        currency: 'KES',
        expectedAdmissionFeeAmount: amount,
        admissionFeeSettingPath: `Settings/${ADMISSION_FEE_SETTINGS_DOC}`,
        paymentMethod: admissionFeeForm.paymentMethod,
        paybill: admissionFeeForm.paymentMethod === 'Mpesa Paybill' ? '444174' : '',
        accountNumber: admissionFeeForm.paymentMethod === 'Mpesa Paybill' ? '001102' : '',
        paymentReference: admissionFeeForm.paymentReference.trim(),
        paymentDate,
        notes: admissionFeeForm.notes.trim(),
        source: 'manual_admin_entry',
        recordedBy: currentUser?.uid || '',
        recordedByEmail: currentUser?.email || '',
        receiptEmailStatus: theuserEmail ? 'pending' : 'skipped_no_email',
        receiptSmsStatus: getKenyanSmsNumber(thephoneNumber) ? 'pending' : 'skipped_non_kenyan',
        createdAt: Timestamp.now(),
      });

      if (!studentRecord.prospectAdmissionNumber) {
        batch.set(doc(db, 'AdmissionReferences', prospectAdmissionNumber), {
          prospectAdmissionNumber,
          userRef: `users/${myData}`,
          source: 'manual_admission_fee_record',
          createdAt: Timestamp.now(),
        });
      }

      const userUpdates = {
        prospectAdmissionNumber,
        admissionFeeStatus: 'paid',
        admissionFeePaidAt: paymentDate,
        admissionFeeAmount: amount,
        admissionFeePaymentMethod: admissionFeeForm.paymentMethod,
        admissionFeePaymentReference: admissionFeeForm.paymentReference.trim(),
        admissionFeePaymentId: paymentRef.id,
        admissionFeeMessageStatus: studentRecord.admissionFeeMessageStatus === 'sent' ? 'sent' : 'not_needed_paid',
        admissionFeeRecordedManually: true,
        admissionFeeRecordedAt: Timestamp.now(),
        admissionFeeRecordedBy: currentUser?.uid || '',
        admissionFeeRecordedByEmail: currentUser?.email || '',
        applicationStage: 'Admission Fee Paid',
        nextFollowUpStatus: 'cancelled',
        nextFollowUpType: 'interview_scheduling',
        nextFollowUpAt: null,
        updatedAt: Timestamp.now(),
      };

      batch.update(doc(db, 'users', myData), userUpdates);
      await batch.commit();

      const receiptStatus = await sendAdmissionFeeReceipt({
        amount,
        paymentReference: admissionFeeForm.paymentReference.trim(),
        paymentMethod: admissionFeeForm.paymentMethod,
        paymentDate,
        prospectAdmissionNumber,
        paymentId: paymentRef.id,
      });

      setStudentRecord((previousRecord) => ({
        ...previousRecord,
        ...userUpdates,
      }));
      setAdmissionFeeModalShow(false);
      resetAdmissionFeeForm();
      const receiptMessage = receiptStatus.emailStatus === 'sent'
        ? "Payment has been saved, reminders cancelled, and the receipt email has been sent."
        : "Payment has been saved and reminders cancelled. Receipt email was not sent, please check the payment record.";
      swal("Admission Fee Recorded", receiptMessage, receiptStatus.emailStatus === 'sent' ? "success" : "warning");
    } catch (error) {
      console.error('Error recording admission fee:', error);
      swal("Recording Failed", error.message || "Admission fee payment could not be recorded.", "error");
    } finally {
      setIsRecordingAdmissionFee(false);
    }
  };


  const [showModal, setShowModal] = useState(false);
  const [admissionDate, setAdmissionDate] = useState('');

  const generateAdmissionNumber = () => {
    return Math.floor(100000 + Math.random() * 900000);
  };

  const reserveUniqueAdmissionNumber = async (studentId, userUpdates = {}) => {
    const maxAttempts = 25;

    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const candidateNumber = generateAdmissionNumber();
      const candidateKey = String(candidateNumber);
      const admissionNumberRef = doc(db, 'AdmissionNumbers', candidateKey);
      const userRef = doc(db, 'users', studentId);

      try {
        await runTransaction(db, async (transaction) => {
          const admissionNumberSnap = await transaction.get(admissionNumberRef);
          if (admissionNumberSnap.exists()) {
            throw new Error('ADMISSION_NUMBER_TAKEN');
          }

          transaction.set(admissionNumberRef, {
            admissionNumber: candidateNumber,
            studentId,
            createdAt: Timestamp.now()
          });
          transaction.update(userRef, {
            ...userUpdates,
            admissionNumber: candidateNumber
          });
        });

        return candidateNumber;
      } catch (error) {
        if (error?.message === 'ADMISSION_NUMBER_TAKEN') {
          continue;
        }

        throw error;
      }
    }

    throw new Error('Unable to generate a unique admission number. Please try again.');
  };

  const handleAdmission = async () => {
    if (admissionDate.trim() === '' || classStartDate.trim() === '') {
      swal("Error", "Please enter all required dates", "error");
      return;
    }

    document.getElementById("submitBtn").style.display = "none";
    document.getElementById("spinnerbtn").style.display = "block";
    try {
      const admissionNumber = await reserveUniqueAdmissionNumber(myData, {
        userStatus: "Student",
        Status: "Active",
        admissionDate: Timestamp.fromDate(new Date(admissionDate)),
        classStartDate: Timestamp.fromDate(new Date(classStartDate))
      });

      const admissionEmailTemplate = buildAdmissionConfirmationEmail({
        studentName: userName,
        admissionNumber,
        course: thecourse,
        duration: mcourseDuration,
        admissionDate: new Date(`${admissionDate}T00:00:00`),
        classStartDate: new Date(`${classStartDate}T00:00:00`),
      });

      const userEmail = theuserEmail;


      //send email

      const emailSubject = `Your ${ORGANIZATION_NAME} Admission Confirmation`;
      const emailAddress = userEmail;

      const emailData = {
        email: emailAddress,
        message: admissionEmailTemplate,
        subject: emailSubject
      };

      const auth = getAuth();
      const user = auth.currentUser;

      user.getIdToken().then((token) => {
        fetch("https://us-central1-ubunifu-college.cloudfunctions.net/api/send-email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify(emailData)
        }).then(() => {

          sendSMS(userName, thecourse, mcourseDuration, classStartDate, admissionNumber, token);

        })
      });








    } catch (error) {
      console.error('Error updating document:', error);
      swal("Error", "An error occurred while admitting the student", "error");
    }
  };


  const sendSMS = async (userName, thecourse, mcourseDuration, classStartDate, admissionNumber, token) => {
    const message = `Congratulations ${userName}! You have been admitted to ${ORGANIZATION_NAME} for ${thecourse} starting ${classStartDate} for the next ${mcourseDuration}. Your Admission Number is ${admissionNumber}. For help, contact Admissions Office on ${ADMISSIONS_PHONE_DISPLAY}. Welcome aboard!`;
    const smsData = {
      phoneNumber: thephoneNumber,
      message: message
    };

    try {
      const response = await fetch("https://us-central1-ubunifu-college.cloudfunctions.net/api/send-sms", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(smsData)
      });

      const data = await response.json();
      console.log(data);
      swal("Success", `Student admitted with Admission Number: ${admissionNumber}`, "success");
      setShowModal(false); // Close the modal
      window.location.reload();
      return true;
    } catch (error) {
      console.error("Error sending SMS: ", error);
      swal("Success", `Student admitted with Admission Number: ${admissionNumber}`, "success");
      setShowModal(false); // Close the modal
      window.location.reload();
      return false;
    }
  };

  const formatDisplayDate = (value) => {
    if (!value) return 'N/A';
    if (value instanceof Timestamp) {
      return value.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }
    if (value?.seconds) {
      const dateFromSeconds = new Date(value.seconds * 1000);
      return dateFromSeconds.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return 'N/A';
    return parsed.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  const calculateAge = (yearOfBirthValue) => {
    if (!yearOfBirthValue) return 'N/A';
    const parts = String(yearOfBirthValue).split('-').map((part) => parseInt(part, 10));
    const year = parts[0];
    const month = parts[1];
    if (!year || Number.isNaN(year)) return 'N/A';
    const today = new Date();
    let age = today.getFullYear() - year;
    if (month && !Number.isNaN(month) && (today.getMonth() + 1) < month) {
      age -= 1;
    }
    return age;
  };

  const calculateGraduationDate = (admissionDateValue, durationValue) => {
    if (!admissionDateValue || !durationValue) return 'N/A';
    let baseDate;
    if (admissionDateValue instanceof Timestamp) {
      baseDate = admissionDateValue.toDate();
    } else if (admissionDateValue?.seconds) {
      baseDate = new Date(admissionDateValue.seconds * 1000);
    } else {
      baseDate = new Date(admissionDateValue);
    }
    if (Number.isNaN(baseDate.getTime())) return 'N/A';

    const months = parseInt(durationValue, 10);
    if (!months || Number.isNaN(months)) return 'N/A';

    const gradDate = new Date(baseDate);
    gradDate.setMonth(gradDate.getMonth() + months);
    return gradDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  // just a random sring type
  const AdmissionModal = ({ show, handleClose, handleAdmission, admissionDate, setAdmissionDate, classStartDate, setClassStartDate }) => (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Admit Student</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <p>Select Admission date</p>
        <input
          type="date"
          value={admissionDate}
          onChange={(e) => setAdmissionDate(e.target.value)}
          className="form-control"
        />
        <br />

        <p>Select Class Start Date</p>
        <input
          type="date"
          value={classStartDate} className="form-control"
          onChange={(e) => setClassStartDate(e.target.value)}
        />
        <br />

        <p>This student will receive an Admission email plus a notification SMS</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleAdmission} id='submitBtn'>
          Admit Student
        </Button>
        <Button variant="primary" disabled id='spinnerbtn' style={{ display: 'none' }}>
          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          <span> Admitting...</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const AdmissionFeeModal = () => (
    <Modal show={admissionFeeModalShow} onHide={() => setAdmissionFeeModalShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Record Admission Fee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Amount paid</Form.Label>
          <Form.Control
            type="text"
            value={formatAdmissionFeeAmount(configuredAdmissionFeeAmount)}
            readOnly
          />
          <Form.Text className="text-muted">
            Edit this amount from Settings → Admission Fee.
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Payment method</Form.Label>
          <Form.Select name="paymentMethod" value={admissionFeeForm.paymentMethod} onChange={handleAdmissionFeeInput}>
            <option value="Mpesa Paybill">Mpesa Paybill</option>
            <option value="Mpesa Till">Mpesa Till</option>
            <option value="Bank Transfer">Bank Transfer</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Other">Other</option>
          </Form.Select>
        </Form.Group>

        {admissionFeeForm.paymentMethod === 'Mpesa Paybill' && (
          <div className="admissionFeePaybillHint">
            <span>Paybill: 444174</span>
            <span>Account: 001102</span>
          </div>
        )}

        <Form.Group className="mb-3">
          <Form.Label>Payment reference</Form.Label>
          <Form.Control
            type="text"
            name="paymentReference"
            value={admissionFeeForm.paymentReference}
            onChange={handleAdmissionFeeInput}
            placeholder="Mpesa code, bank ref, or receipt number"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Payment date</Form.Label>
          <Form.Control
            type="date"
            name="paymentDate"
            value={admissionFeeForm.paymentDate}
            onChange={handleAdmissionFeeInput}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Notes</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="notes"
            value={admissionFeeForm.notes}
            onChange={handleAdmissionFeeInput}
            placeholder="Optional internal note"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setAdmissionFeeModalShow(false)} disabled={isRecordingAdmissionFee}>
          Close
        </Button>
        <Button variant="primary" onClick={recordAdmissionFeePayment} disabled={isRecordingAdmissionFee}>
          {isRecordingAdmissionFee && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
          <span>{isRecordingAdmissionFee ? ' Recording...' : 'Record Payment'}</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );


  function graduateStudent() {
    Swal.fire({
      title: 'Graduate Student?',
      html: `
            <p>Are you sure you want to Graduate ${userName}? Select the graduation date below</p>
            <input type="date" id="date-picker" class="swal2-input" />
          `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, graduate!',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const datePicker = Swal.getPopup().querySelector('#date-picker').value;
        if (!datePicker) {
          Swal.showValidationMessage('Please select a graduation date');
          return false;
        }
        return datePicker;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedDate = result.value;
        const dateObj = new Date(selectedDate);
        const timestamp = Timestamp.fromDate(dateObj);

        // Update the document with the new timestamp
        updateDoc(doc(db, 'users', myData), {
          userStatus: 'Completed',
          graduatedTime: timestamp // Save as a Firestore Timestamp
        }).then(() => {
          Swal.fire('Success!', 'The student has been graduated.', 'success');
          window.location.reload()
        }).catch((error) => {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        });
      } else {
        Swal.fire('Action Cancelled!');
      }
    });
  }


  function differStudent() {

    Swal.fire({
      title: 'Defer Student?',
      html: `
              <p>Are you sure you want to Defer ${userName}? Select the deferred date below</p>
              <input type="date" id="date-picker" class="swal2-input" />
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Defer!',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const datePicker = Swal.getPopup().querySelector('#date-picker').value;
        if (!datePicker) {
          Swal.showValidationMessage('Please select the deffered date');
          return false;
        }
        return datePicker;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedDate = result.value;
        const dateObj = new Date(selectedDate);
        const timestamp = Timestamp.fromDate(dateObj);

        // Update the document with the new timestamp
        updateDoc(doc(db, 'users', myData), {
          userStatus: 'Deferred',
          diferTime: timestamp // Save as a Firestore Timestamp
        }).then(() => {
          Swal.fire('Success!', 'The student has deferred.', 'success');
          window.location.reload()
        }).catch((error) => {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        });
      } else {
        Swal.fire('Action Cancelled!');
      }
    });

  }

  function expellStudent() {

    Swal.fire({
      title: 'Expell Student?',
      html: `
              <p>Are you sure you want to Expell ${userName}? Select the expelled date below</p>
              <input type="date" id="date-picker" class="swal2-input" />
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, expell!',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const datePicker = Swal.getPopup().querySelector('#date-picker').value;
        if (!datePicker) {
          Swal.showValidationMessage('Please select a expell date');
          return false;
        }
        return datePicker;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedDate = result.value;
        const dateObj = new Date(selectedDate);
        const timestamp = Timestamp.fromDate(dateObj);

        // Update the document with the new timestamp
        updateDoc(doc(db, 'users', myData), {
          userStatus: 'Expelled',
          expelledTime: timestamp // Save as a Firestore Timestamp
        }).then(() => {
          Swal.fire('Success!', 'The student has been expelled.', 'success');
          window.location.reload()
        }).catch((error) => {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        });
      } else {
        Swal.fire('Action Cancelled!');
      }
    });

  }

  function dropStudent() {

    Swal.fire({
      title: 'Drop Student?',
      html: `
              <p>Are you sure you want to Drop ${userName}? Select the Dropped date below</p>
              <input type="date" id="date-picker" class="swal2-input" />
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, drop!',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const datePicker = Swal.getPopup().querySelector('#date-picker').value;
        if (!datePicker) {
          Swal.showValidationMessage('Please select the drop date');
          return false;
        }
        return datePicker;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedDate = result.value;
        const dateObj = new Date(selectedDate);
        const timestamp = Timestamp.fromDate(dateObj);

        // Update the document with the new timestamp
        updateDoc(doc(db, 'users', myData), {
          userStatus: 'Dropped',
          droppedTime: timestamp // Save as a Firestore Timestamp
        }).then(() => {
          Swal.fire('Success!', 'The student has Dropped.', 'success');
          window.location.reload()
        }).catch((error) => {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        });
      } else {
        Swal.fire('Action Cancelled!');
      }
    });

  }

  function pauseLearning() {
    if (theuserType !== 'Student') {
      Swal.fire('Only Active Students', 'Only active students can be added to Learning Breaks.', 'info');
      return;
    }

    Swal.fire({
      title: 'Pause Learning?',
      html: `
              <p>Move ${userName} to Learning Breaks and set when they are expected to resume.</p>
              <input type="date" id="pause-date-picker" class="swal2-input" />
              <input type="date" id="resume-date-picker" class="swal2-input" />
              <input type="text" id="pause-reason" class="swal2-input" placeholder="Reason for pause" />
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, pause learning',
      cancelButtonText: 'Cancel',
      didOpen: () => {
        const today = getTodayDateInputValue();
        const pausePicker = Swal.getPopup().querySelector('#pause-date-picker');
        const resumePicker = Swal.getPopup().querySelector('#resume-date-picker');
        pausePicker.value = today;
        resumePicker.min = today;
      },
      preConfirm: () => {
        const pauseDate = Swal.getPopup().querySelector('#pause-date-picker').value;
        const resumeDate = Swal.getPopup().querySelector('#resume-date-picker').value;
        const reason = Swal.getPopup().querySelector('#pause-reason').value.trim();

        if (!pauseDate) {
          Swal.showValidationMessage('Please select the pause date');
          return false;
        }

        if (!resumeDate) {
          Swal.showValidationMessage('Please select the expected resume date');
          return false;
        }

        return { pauseDate, resumeDate, reason };
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const studentRef = doc(db, 'users', myData);
          const studentSnapshot = await getDoc(studentRef);
          const latestStatus = studentSnapshot.data()?.userStatus;

          if (!studentSnapshot.exists() || latestStatus !== 'Student') {
            Swal.fire('Only Active Students', 'This student is no longer active, so they cannot be added to Learning Breaks.', 'info');
            return;
          }

          const dateObj = new Date(result.value.pauseDate);
          const timestamp = Timestamp.fromDate(dateObj);
          const pauseReason = result.value.reason || 'Learning pause';

          await updateDoc(studentRef, {
            userStatus: 'Paused',
            pauseReason,
            expectedResumeDate: result.value.resumeDate,
            pausedAt: timestamp,
            learningPause: {
              status: 'paused',
              previousStatus: 'Student',
              reason: pauseReason,
              expectedResumeDate: result.value.resumeDate,
              pausedAt: timestamp
            }
          });

          Swal.fire('Success!', 'The student has been moved to Learning Breaks.', 'success');
          window.location.reload()
        } catch (error) {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        }
      } else {
        Swal.fire('Action Cancelled!');
      }
    });

  }

  function resumeLearning() {

    Swal.fire({
      title: 'Resume Learning?',
      html: `
              <p>Are you sure you want to Resume Learning for  ${userName}? Select the resumption date below</p>
              <input type="date" id="date-picker" class="swal2-input" />
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, resume!',
      cancelButtonText: 'Cancel',
      preConfirm: () => {
        const datePicker = Swal.getPopup().querySelector('#date-picker').value;
        if (!datePicker) {
          Swal.showValidationMessage('Please select the resumption date');
          return false;
        }
        return datePicker;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedDate = result.value;
        const dateObj = new Date(selectedDate);
        const timestamp = Timestamp.fromDate(dateObj);

        // Update the document with the new timestamp
        updateDoc(doc(db, 'users', myData), {
          userStatus: 'Student',
          resumeTime: timestamp,
          resumedAt: timestamp,
          learningPause: {
            status: 'resumed',
            previousStatus: theuserType,
            reason: studentRecord.pauseReason || studentRecord.learningPause?.reason || '',
            notes: studentRecord.pauseNotes || studentRecord.learningPause?.notes || '',
            expectedResumeDate: studentRecord.expectedResumeDate || studentRecord.learningPause?.expectedResumeDate || '',
            pausedAt: studentRecord.pausedAt || studentRecord.learningPause?.pausedAt || null,
            resumedAt: timestamp
          }
        }).then(() => {
          Swal.fire('Success!', 'The student has Resumed Learning', 'success');
          window.location.reload()
        }).catch((error) => {
          Swal.fire('Error!', `There was an error: ${error.message}`, 'error');
        });
      } else {
        Swal.fire('Action Cancelled!');
      }
    });

  }





  return (
    <div className='clientsComp studentProfilePage'>
      <div className='studentHeader'>
        <div className='studentHeaderMain'>
          <div className='studentAvatar'>
            <img src={theprofilePic} alt="" />
          </div>
          <div className='studentHeaderInfo'>
            <div className='studentNameRow'>
              <h3>{userName || 'Student Profile'}</h3>
              <span className={`studentStatusBadge ${statusSlug}`}>{theuserType || 'Unknown'}</span>
            </div>
            <p className='studentHeaderMeta'>{thecourse || 'Course not set'} • {thecohort || 'Cohort TBD'}</p>
            <div className='studentHeaderSub'>
              <span>{theuserEmail || 'Email not set'}</span>
              <span>{thenationality || 'Nationality not set'}</span>
              <span>{thephoneNumber || 'Phone not set'}</span>
            </div>
          </div>
        </div>

        <div className='viewstudentButtonCont studentActions'>
          {isInactiveStudent && (
            <>
              <button className='viewBtn1' onClick={() => setShowModal(true)}>
                <FontAwesomeIcon icon={faAdd} /> Admit
              </button>
              <button className='viewBtn2' onClick={() => setModalShowUp(true)}>
                <FontAwesomeIcon icon={faAdd} /> Not Joining
              </button>
              <button className='viewBtn3' onClick={() => setModalShowUp2(true)}>
                <FontAwesomeIcon icon={faAdd} /> Change Course
              </button>
              <button
                className='viewBtn4'
                onClick={() => setAdmissionFeeModalShow(true)}
                disabled={studentRecord.admissionFeeStatus === 'paid'}
              >
                <FontAwesomeIcon icon={faWallet} /> {studentRecord.admissionFeeStatus === 'paid' ? 'Admission Fee Paid' : 'Record Admission Fee'}
              </button>
            </>
          )}

          {theuserType === 'Student' && (
            <>
              <button className='viewBtn3' onClick={graduateStudent}>
                <FontAwesomeIcon icon={faAdd} /> Graduate
              </button>
              <button className='viewBtn4' onClick={differStudent}>
                <FontAwesomeIcon icon={faAdd} /> Differ
              </button>
              <button className='viewBtn2' onClick={expellStudent}>
                <FontAwesomeIcon icon={faAdd} /> Expell
              </button>
              <button className='viewBtn2' onClick={dropStudent}>
                <FontAwesomeIcon icon={faAdd} /> Drop
              </button>
              <button className='viewBtn4' onClick={pauseLearning}>
                <FontAwesomeIcon icon={faAdd} /> Pause Learning
              </button>
            </>
          )}

          {theuserType === 'Did Not Join' && (
            <button className='viewBtn1' onClick={() => setShowModal(true)}>
              <FontAwesomeIcon icon={faAdd} /> Admit
            </button>
          )}

          {(theuserType === 'Dropped' || theuserType === 'Expelled' || theuserType === 'Deferred' || theuserType === 'Paused') && (
            <button className='viewBtn3' onClick={resumeLearning}>
              <FontAwesomeIcon icon={faAdd} /> Resume Learning
            </button>
          )}
        </div>
      </div>

      {isInactiveStudent && (
        <div className='studentAdmissionFollowUpCard'>
          <div className='studentAdmissionFollowUpTop'>
            <div>
              <p className='studentSectionLabel'>Admissions pipeline</p>
              <h6>{studentRecord.applicationStage || 'Application Received'}</h6>
            </div>
            <span className={`studentFollowUpChip ${getStatusTone(studentRecord.nextFollowUpStatus)}`}>
              {formatStatusText(studentRecord.nextFollowUpStatus || 'pending')}
            </span>
          </div>

          <div className='studentAdmissionFollowUpGrid'>
            <div>
              <span>Application Ref</span>
              <strong>{studentRecord.prospectAdmissionNumber || 'Pending generation'}</strong>
            </div>
            <div>
              <span>Next Follow-up</span>
              <strong>{getNextFollowUpSummary()}</strong>
            </div>
            <div>
              <span>Next Action</span>
              <strong>{formatStatusText(studentRecord.nextFollowUpType || 'admission_fee')}</strong>
            </div>
            <div>
              <span>Admission Fee</span>
              <strong>{formatStatusText(studentRecord.admissionFeeStatus || 'pending')}</strong>
            </div>
            <div>
              <span>Message Status</span>
              <strong>{formatStatusText(studentRecord.admissionFeeMessageStatus || 'pending')}</strong>
            </div>
            <div>
              <span>Email Status</span>
              <strong>{formatStatusText(studentRecord.admissionFeeEmailStatus || studentRecord.emailStatus || 'pending')}</strong>
            </div>
            <div>
              <span>SMS Status</span>
              <strong>{formatStatusText(studentRecord.admissionFeeSmsStatus || studentRecord.smsStatus || 'pending')}</strong>
            </div>
          </div>

          <div className='studentAdmissionFollowUpFooter'>
            <span>Lead source: {formatStatusText(studentRecord.leadSource || thehear)}</span>
            <span>Phone cleaned: {formatStatusText(studentRecord.phoneCleaned)}</span>
            <span>Follow-ups sent: {studentRecord.followUpCount || 0}</span>
          </div>
        </div>
      )}

      <div className='studentStatsGrid'>
        <div className='studentStatCard'>
          <div className='studentStatIcon'>
            <FontAwesomeIcon icon={faWallet} />
          </div>
          <div>
            <p>Total Fee</p>
            <h4>KES {formatKES(themcoursePrice)}</h4>
          </div>
        </div>
        <div className='studentStatCard'>
          <div className='studentStatIcon'>
            <FontAwesomeIcon icon={faSquareCheck} />
          </div>
          <div>
            <p>Fee Paid</p>
            <h4>KES {formatKES(totalAmountReceived)}</h4>
          </div>
        </div>
        <div className='studentStatCard'>
          <div className='studentStatIcon'>
            <FontAwesomeIcon icon={faHourglassHalf} />
          </div>
          <div>
            <p>Fee Balance</p>
            <h4>KES {formatKES(thefeebalanceState)}</h4>
          </div>
        </div>
        <div className='studentStatCard'>
          <div className='studentStatIcon'>
            <FontAwesomeIcon icon={faCalendar} />
          </div>
          <div>
            <p>Payment Due</p>
            <h4>{formatDisplayDate(studentAdmissionDate)}</h4>
          </div>
        </div>
      </div>

      <div className='studentContentGrid'>
        <div className='studentCard'>
          <div className='studentCardHeader'>
            <h6>About the student</h6>
          </div>
          <div className='studentCardBody'>
            <p className='aboutTextInfo'>{theaboutMe || 'No bio provided yet.'}</p>
            <p className='studentSectionLabel'>Why the student joined</p>
            <p className='aboutTextInfo'>{thewhyInterested || 'No notes provided.'}</p>

            <div className='studentMetaGrid'>
              <div>
                <span>Cohort Date</span>
                <strong>{thecohort || 'N/A'}</strong>
              </div>
              <div>
                <span>Graduating Date</span>
                <strong>{calculateGraduationDate(studentAdmissionDate, courseDurationMonths)}</strong>
              </div>
              <div>
                <span>Class Session</span>
                <strong>{thesessionTime || 'N/A'}</strong>
              </div>
              <div>
                <span>Class Type</span>
                <strong>{theclassType || 'N/A'}</strong>
              </div>
            </div>

            <p className='studentSectionLabel'>People in this class</p>
            <div className='classmatesList'>
              {classmates.map((classmate, index) => (
                <div key={index} className='classmateItem' onClick={() => viewStudent(classmate.userId)}>
                  <div className='classmateItemImg'>
                    <img src={classmate.profilePic || profilePictureContImage} alt={`${classmate.bio}'s profile`} />
                  </div>
                  <p>{getFirstName(classmate.bio)}</p>
                </div>
              ))}
              {classmates.length === 0 && (
                <span className='studentEmptyInline'>No classmates found for this cohort.</span>
              )}
            </div>
          </div>
        </div>

        <div className='studentCard'>
          <div className='studentCardHeader'>
            <h6>Student Details</h6>
          </div>
          <div className='studentCardBody'>
            <div className='studentDetailRow'>
              <span>Application Date</span>
              <strong>{formatDateTime(theappDate)}</strong>
            </div>
            <div className='studentDetailRow'>
              <span>Admission Number</span>
              <strong>{theAdmissionNumber || 'N/A'}</strong>
            </div>
            <div className='studentDetailRow'>
              <span>Age</span>
              <strong>{calculateAge(theYearOfBirth)}</strong>
            </div>
            <div className='studentDetailRow'>
              <span>Found us via</span>
              <strong>{thehear || 'N/A'}</strong>
            </div>
            <div className='studentDetailRow'>
              <span>Certificate</span>
              <Button className='appsViewBtn' onClick={handleViewCertificate} disabled={!canViewCertificate}>
                View Certificate
              </Button>
            </div>
            <div className='studentDetailRow'>
              <span>School ID</span>
              <Button className='appsViewBtn' onClick={handleViewSchoolId} disabled={!canViewSchoolId}>
                View School ID
              </Button>
            </div>
            {!canViewSchoolId && (
              <small className="text-muted">Available after admission</small>
            )}
          </div>
        </div>
      </div>

      <div className="appsTableCard">
        <div className="appsTableHeader">
          <h6>Fee Payment History</h6>
          <span>{studentsList.length} payments</span>
        </div>
        <div className="appsTableWrap">
          <Table hover responsive className="appsTable">
            <thead>
              <tr>
                <th>Payment Date</th>
                <th>Payment Method</th>
                <th>Amount</th>
                <th>View Receipts</th>
              </tr>
            </thead>
            <tbody>
              {studentsList.map((mystudent) => (
                <tr key={mystudent.id}>
                  <td>{formatDateTime(mystudent.paymentDate)}</td>
                  <td>{mystudent.paymentMethod}</td>
                  <td>KES {formatKES(mystudent.incomeAmount)}</td>
                  <td>
                    <button className='appsViewBtn' onClick={() => handleViewReceipt(mystudent)}>
                      View Receipt
                    </button>
                  </td>
                </tr>
              ))}
              {studentsList.length === 0 && (
                <tr>
                  <td colSpan="4" className="appsEmptyState">
                    No fee payments recorded yet.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <AdmissionModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleAdmission={handleAdmission}
        admissionDate={admissionDate}
        setAdmissionDate={setAdmissionDate}
        classStartDate={classStartDate}
        setClassStartDate={setClassStartDate}
      />
      <AdmissionFeeModal />
      <MyUpdateModal show={modalShowUp} onHide={() => setModalShowUp(false)} />
      <MyUpdateModal2 show={modalShowUp2} onHide={() => setModalShowUp2(false)} />
    </div>
  )
}

export default ViewStudentComp
